export const HPPSA_AGREE_REDIRECT = 'hppsanone://agree'; 
export const HPPSA_DECLINE_REDIRECT = 'hppsanone://decline';
export const HPPSA_ON_REDIRECT = 'hppsanone://app-analytics=on'; 
export const HPPSA_OFF_REDIRECT = 'hppsanone://app-analytics=off';
